import { computed, Ref } from '@vue/composition-api';
import { useCreativeExtendStore } from '@tt4b/ttam-hooks';
import { AdgroupFormData, CampaignFormData, isHTTPSReg, NormalCreative } from '@tt4b/ttam-enums';

/**
 * URL http校验状态
 */
export const useCheckUrlEffect = (options: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  normalCreativeData: Ref<NormalCreative>;
  activeSplitTestIndex: Ref<number>;
}) => {
  const { adgroupData, campaignData, normalCreativeData, activeSplitTestIndex } = options;
  const { creativeExtendAdSourceAdTypeGet, creativeExtendAdSourceAdTypeSet } = useCreativeExtendStore({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
    normalCreativeData,
    activeSplitTestIndex,
  });

  const setIsStartWithHTTPS = (val = '') => {
    // URL为空，也不出现相关提示
    if (val === '') {
      creativeExtendAdSourceAdTypeSet('isURLStartWithHttps', true);
    } else {
      creativeExtendAdSourceAdTypeSet('isURLStartWithHttps', isHTTPSReg.test(val));
    }
  };

  const computedIsUrlStartWithHttps = computed(
    () =>
      // https开头 || 默认状态下不展示
      creativeExtendAdSourceAdTypeGet('isURLStartWithHttps') === true ||
      creativeExtendAdSourceAdTypeGet('isURLStartWithHttps') === undefined
  );

  return {
    setIsStartWithHTTPS,
    computedIsUrlStartWithHttps,
  };
};
